import React from 'react';
import { Swiper, SwiperSlide, useSwiper } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import { Pagination, Navigation } from 'swiper/modules';
import Image from 'next/image';
import clsx from 'clsx';
import { ChevronLeft, ChevronRight } from 'lucide-react';

interface Props {
	listItems: string[];
	className?: string;
	classNameSlide?: string;
	classNameImage?: string;
}

export const HeroSlider: React.FC<Props> = ({
	listItems,
	className,
	classNameSlide,
	classNameImage,
}) => {
	const swiper = useSwiper();

	return (
		<div className="relative">
			<Swiper
				slidesPerView={1}
				spaceBetween={30}
				loop={true}
				pagination={{
					el: '.custom-pagination',
					clickable: true,
					renderBullet: (_index, className) => {
						return `<button class="${className} my-custom-dot-class"></button>`;
					},
				}}
				navigation={{
					nextEl: '.custom-next',
					prevEl: '.custom-prev',
				}}
				modules={[Pagination, Navigation]}
				className={clsx('w-[370px] h-[350px]', className)}
			>
				{listItems?.map((image, index) => (
					<SwiperSlide
						key={index}
						className={clsx('relative max-h-[308px]', classNameSlide)}
					>
						<Image
							src={image}
							alt=""
							fill
							sizes="100vw"
							className={clsx('object-contain object-bottom', classNameImage)}
						/>
					</SwiperSlide>
				))}
			</Swiper>
			<div className="flex w-full items-center justify-center gap-x-[52px] mt-[86px]">
				<button
					className="custom-prev !w-8 !h-8 border border-purple-150 rounded-full flex justify-center items-center"
					onClick={() => swiper?.slidePrev()}
					aria-label="Previous Slide"
				>
					<ChevronLeft width={16} height={16} color="#8039DF" />
				</button>
				<div className="hidden !w-fit custom-pagination items-center md:flex justify-center gap-x-[10px]" />
				<button
					className="custom-next !w-8 !h-8 border border-purple-150 rounded-full flex justify-center items-center"
					onClick={() => swiper?.slideNext()}
					aria-label="Next Slide"
				>
					<ChevronRight width={16} height={16} color="#8039DF" />
				</button>
			</div>
		</div>
	);
};
